import { QUICK_SEARCH_ACTIONS } from "../configuration/QuickSearchActions"
import type { QuickSearchAction } from "../configuration/QuickSearchActions"
import type { Employee } from "../Objects/Employee/Employee"
import type { SystemModuleType } from "../Enum/SystemModuleType"
import { canAccessRestrictedPage } from "./employeeAccess"

export const getAvailableQuickSearchActions = (
  userEmployee: Pick<Employee, "isMaster" | "permissions"> | null | undefined,
  isModuleEnabled: (moduleCode?: SystemModuleType) => boolean,
): QuickSearchAction[] =>
  QUICK_SEARCH_ACTIONS.filter(
    (action) =>
      (!action.ownerOnly || userEmployee?.isMaster === true) &&
      canAccessRestrictedPage(action.permission, action.module, userEmployee?.permissions, isModuleEnabled),
  )
